import React from 'react';
import './Preloader.css';

function Preloader({ customMargin }) {
    return (
        <div style={{margin: `${customMargin}px auto`}} className="preloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}

export default Preloader;